import { render, staticRenderFns } from "./ChangeEmail.vue?vue&type=template&id=4958853b&scoped=true"
import script from "./ChangeEmail.vue?vue&type=script&lang=js"
export * from "./ChangeEmail.vue?vue&type=script&lang=js"
import style0 from "./ChangeEmail.vue?vue&type=style&index=0&id=4958853b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4958853b",
  null
  
)

export default component.exports